function parseOtherCharges(otherCharges) {
    if (!otherCharges) return null;
    if (typeof otherCharges === 'object') return otherCharges;
    if (typeof otherCharges !== 'string') return null;
    try {
        return JSON.parse(otherCharges);
    } catch {
        return null;
    }
}

function populatedName(ref) {
    if (!ref || typeof ref !== 'object') return '';
    return ref.name || ref.title || '';
}

export function getPackageName(voucher) {
    return (
        populatedName(voucher?.subscription_id?.package_id) ||
        populatedName(voucher?.member_id?.package_id) ||
        ''
    );
}

export function getTrainerName(voucher) {
    return (
        populatedName(voucher?.trainer_id) ||
        populatedName(voucher?.member_id?.trainer_id) ||
        ''
    );
}

export function getDiscountAmount(voucher) {
    if (voucher?.voucher_type === 'Receipt') {
        return Number(voucher?.receipt?.discount) || 0;
    }
    return Number(voucher?.invoice?.discount) || 0;
}

export function getGrossAmount(voucher) {
    if (voucher?.voucher_type === 'Receipt') {
        return Number(voucher?.paid_amount) || Number(voucher?.receipt?.amount) || 0;
    }

    const invoice = voucher?.invoice || {};
    const other = parseOtherCharges(invoice.other_charges);
    const otherAmount = Number(other?.amount) || 0;
    const componentTotal =
        (Number(invoice.membership_fee) || 0) +
        (Number(invoice.registration_fee) || 0) +
        (Number(invoice.trainer_fee) || 0) +
        (Number(invoice.facilities_fee) || 0) +
        otherAmount;

    if (componentTotal > 0) return componentTotal;
    return Number(invoice.total_amount) || Number(voucher?.paid_amount) || 0;
}

export function getNetAmount(voucher) {
    if (voucher?.voucher_type === 'Receipt') {
        return Number(voucher?.paid_amount) || 0;
    }
    const net = getGrossAmount(voucher) - getDiscountAmount(voucher);
    return net > 0 ? net : 0;
}

export function getVoucherCompleteHead(voucher) {
    if (voucher?.voucher_type === 'Receipt') {
        return voucher?.receipt?.remarks || 'Receipt';
    }

    const invoice = voucher?.invoice || {};
    const other = parseOtherCharges(invoice.other_charges);
    const otherAmount = Number(other?.amount) || 0;
    const trainerName = getTrainerName(voucher);
    const heads = [];

    if ((Number(invoice.membership_fee) || 0) > 0) heads.push('Membership Fee');
    if ((Number(invoice.registration_fee) || 0) > 0) heads.push('Registration Fee');
    if ((Number(invoice.trainer_fee) || 0) > 0) {
        heads.push(trainerName ? `Trainer Fee (${trainerName})` : 'Trainer Fee');
    }
    if ((Number(invoice.facilities_fee) || 0) > 0) heads.push('Facilities Fee');
    if (otherAmount > 0) heads.push(other?.name || 'Other Charges');

    if (heads.length === 0) {
        return voucher?.voucher_type || '';
    }
    return heads.join(', ');
}

export function withFeeCollectionExtraFields(voucher) {
    return {
        ...voucher,
        package_name: getPackageName(voucher) || '—',
        trainer_name: getTrainerName(voucher) || '—',
        voucher_complete_head: getVoucherCompleteHead(voucher) || '—',
        gross_amount: getGrossAmount(voucher),
        discount_amount: getDiscountAmount(voucher),
        net_amount: getNetAmount(voucher),
    };
}

export function uniqueBankGlOptions(vouchers = [], bankAccounts = []) {
    const values = new Set();
    bankAccounts.forEach((account) => {
        const gl = account?.bank_gl?.toString().trim();
        if (gl) values.add(gl);
    });
    vouchers.forEach((voucher) => {
        const gl = voucher?.bank_gl?.toString().trim();
        if (gl) values.add(gl);
    });
    return Array.from(values).sort((a, b) => a.localeCompare(b));
}

export function matchesBankGlFilter(voucher, bankGlFilter) {
    if (!bankGlFilter || bankGlFilter === 'All') return true;
    const gl = voucher?.bank_gl?.toString().trim() || '';
    if (bankGlFilter === 'none') return gl === '';
    return gl === bankGlFilter;
}

